import dayjs from "dayjs";

export const dateFormat = (date?: string, format: string = 'DD/MM/YYYY') => {
    if (!date) {
        return '';
    }

    return dayjs(date).format(format);
}
